module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.prefix) ? [_vm._v(_vm._s(_vm.prefix))] : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "nudge-bottom": 0
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({
          staticClass: "label-menu",
          class: {
            'label-menu-hoverable': !_vm.underline
          }
        }, on), [_c('span', {
          class: {
            'dotted-underline': _vm.underline
          }
        }, [_vm._v("\n                " + _vm._s(_vm.buttonText) + "\n            ")]), _vm._v(" "), (!_vm.underline) ? _c('v-icon', [_vm._v("mdi-menu-down")]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.menuVisible),
      callback: function($$v) {
        _vm.menuVisible = $$v
      },
      expression: "menuVisible"
    }
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.menus), function(menu, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.menuClicked(menu)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(menu.text || menu.value))])], 1)
  }), 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c85a38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LabelMenu.vue
// module id = 2485
// module chunks = 1